import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=62ca47cc&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=ts"
export * from "./MyProfile.vue?vue&type=script&lang=ts"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=62ca47cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca47cc",
  null
  
)

export default component.exports